// Where players reach a human; the legal texts quote the same default address.
export const SUPPORT_EMAIL =
  (process.env.REACT_APP_SUPPORT_EMAIL as string | undefined) || "support@skystake.bet";

export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
